import CONSTANTS from '../constants';

export function alert(state = {}, action) {
	switch (action.type) {
		case CONSTANTS.ALERTS.SUCCESS:
			return {
				type: 'alert-success',
				message: action.message
			};
		case CONSTANTS.ALERTS.ERROR:
			return {
				type: 'alert-danger',
				message: action.message
			};
		case CONSTANTS.ALERTS.CLEAR:
			return {};
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/alertsReducer.js